'use client'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Suspense, useState } from 'react'
import OverlayLoading from '~/components/ui/overlay-loading'
import { useCleanTrackingParams } from '~/hooks/use-clean-tracking-params'
import { useLoyaltySession } from '~/hooks/use-loyalty-session'
import { AnalyticsProvider } from '~/components/analytics/PostHogProvider'
import { DataAttributeTracker } from '~/components/analytics/DataAttributeTracker'
import { TimeOnPageTracker } from '~/components/analytics/TimeOnPageTracker'
import { ScrollTracker } from '~/components/analytics/ScrollTracker'

function TrackingParamsCleaner() {
  useCleanTrackingParams()
  return null
}

// Mounted globally so the silent-refresh scheduling in useLoyaltySession runs
// regardless of which page/component the user is on, not just when the
// header's AuthSection happens to be mounted.
function LoyaltySessionKeeper() {
  useLoyaltySession()
  return null
}

export default function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => new QueryClient())

  return (
    <AnalyticsProvider>
      <QueryClientProvider client={queryClient}>
        <TrackingParamsCleaner />
        <LoyaltySessionKeeper />
        <DataAttributeTracker />
        <ScrollTracker />
        <Suspense>
          <TimeOnPageTracker />
        </Suspense>
        <Suspense fallback={<OverlayLoading show={true} />}>{children}</Suspense>
      </QueryClientProvider>
    </AnalyticsProvider>
  )
}
